import {useQuery} from '@apollo/client';
import * as React from 'react';
import {useNavigate, useParams} from 'react-router';

import {Unit, tipoDeAula} from '../coursesList';
import {QUERY_STUDENT_UNIT} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

interface UnitDetail extends Unit {
  course?: {id: string; title?: string | null} | null;
}

interface UnitData {
  unit?: UnitDetail | null;
}

interface Props {
  theme: StudentTheme;
}

export const UnitDetailScreen: React.FC<Props> = ({theme}) => {
  const {unitId} = useParams();
  const navigate = useNavigate();

  const {data, loading, error, refetch} = useQuery<UnitData>(QUERY_STUDENT_UNIT, {
    variables: {id: unitId},
    skip: !unitId,
  });

  const aula = data?.unit;

  return (
    <div className="curso-detalhe">
      <button
        type="button"
        className="wod-detalhe__voltar student-app__retry"
        style={{color: theme.primary}}
        onClick={() => navigate(-1)}
      >
        <i className="fa-light fa-chevron-left" aria-hidden="true" />{' '}
        {aula?.course?.title ? `Voltar para ${aula.course.title}` : 'Voltar'}
      </button>

      {loading && <p className="student-screen__estado">Carregando…</p>}

      {error && !loading && (
        <div className="student-screen__estado">
          <p>Não foi possível carregar a aula.</p>
          <button type="button" className="student-app__retry" onClick={() => refetch()}>
            Tentar de novo
          </button>
        </div>
      )}

      {!loading && !error && !aula && <p className="student-screen__estado">Aula não encontrada.</p>}

      {!loading && !error && aula && (
        <article className="wod-detalhe__conteudo" style={{backgroundColor: theme.body, borderColor: theme.border}}>
          <header className="wod-detalhe__topo">
            <h2 className="wod-card__nome">{aula.title}</h2>
            {aula.completed && (
              <i
                className="fa-solid fa-circle-check wod-card__feito"
                style={{color: theme.primary}}
                aria-label="Concluída"
              />
            )}
          </header>

          {tipoDeAula(aula) && (
            <span className="curso-aula__tipo" style={{color: theme.neutral}}>
              {tipoDeAula(aula)}
            </span>
          )}

          {aula.video?.uri && (
            <video className="curso-aula__midia" src={aula.video.uri} controls playsInline preload="metadata" />
          )}

          {aula.audio?.uri && <audio className="curso-aula__midia" src={aula.audio.uri} controls preload="metadata" />}

          {!aula.video?.uri && !aula.audio?.uri && aula.cover?.uri && (
            <img className="curso-detalhe__capa" src={aula.cover.uri} alt="" loading="lazy" />
          )}

          {aula.description && <p className="wod-card__descricao">{aula.description}</p>}
        </article>
      )}
    </div>
  );
};
